import { useEffect, useState } from 'react';

import { CarouselApi } from '@/shared/ui';

interface UseSelectedSnapDisplayType {
  selectedSnap: number;
  snapCount: number;
}

export const useSelectedSnapDisplay = (
  emblaApi: CarouselApi | undefined | null,
): UseSelectedSnapDisplayType => {
  const [selectedSnap, setSelectedSnap] = useState(0);
  const [snapCount, setSnapCount] = useState(0);

  const updateScrollSnapState = (emblaApi: CarouselApi) => {
    if (!emblaApi) return;

    setSnapCount(emblaApi.scrollSnapList().length);
    setSelectedSnap(emblaApi.selectedScrollSnap());
  };

  useEffect(() => {
    if (!emblaApi) return;

    updateScrollSnapState(emblaApi);

    emblaApi.on('select', updateScrollSnapState);
    emblaApi.on('reInit', updateScrollSnapState);
  }, [emblaApi, updateScrollSnapState]);

  return {
    selectedSnap,
    snapCount,
  };
};
